import { render, staticRenderFns } from "./CommercialCard.vue?vue&type=template&id=562ba0e7&scoped=true"
import script from "./CommercialCard.vue?vue&type=script&lang=js"
export * from "./CommercialCard.vue?vue&type=script&lang=js"
import style0 from "./CommercialCard.vue?vue&type=style&index=0&id=562ba0e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ba0e7",
  null
  
)

export default component.exports